// extracted by mini-css-extract-plugin
export default {"swipper-container":"styles_swipper-container__47jkz","swipper":"styles_swipper__vRYU0","circle":"styles_circle__Dw2+u","active":"styles_active__34vnw"};